import { createContext, useContext, useEffect, useState } from "react";
import { api, tokenStore } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, object=logged in
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const t = tokenStore.get();
    if (!t) {
      setUser(false);
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => {
        if (!cancelled) setUser(r.data);
      })
      .catch(() => {
        tokenStore.clear();
        if (!cancelled) setUser(false);
      })
      .finally(() => {
        if (!cancelled) setReady(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    tokenStore.set(r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    tokenStore.clear();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
